import { render, staticRenderFns } from "./AppTopbar.vue?vue&type=template&id=aa4edd9c&"
import script from "./AppTopbar.vue?vue&type=script&lang=js&"
export * from "./AppTopbar.vue?vue&type=script&lang=js&"
import style0 from "./AppTopbar.vue?vue&type=style&index=0&id=aa4edd9c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports